import { Status } from 'civic-champs-shared/api/hooks/fetchRefactoredSchema'
import useFetchRefactored from 'civic-champs-shared/api/hooks/useFetchRefactored'
import { useCallback } from 'react'
import { Note } from 'note/Note'
import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'

const useGetBulkPersonNotes = (): [(personIds: number[]) => Promise<Note[]>, Status<Note[]>] => {
  const [request, status] = useFetchRefactored<Note[]>({ emptyValue: [] })
  const organization = useCurrentOrg()

  const getBulkPersonNotes = useCallback(
    (personIds: number[]) => {
      if (!personIds.length) {
        return Promise.resolve([])
      }

      return request({
        method: 'post',
        url: `/organizations/${organization.id}/person/notes/bulk`,
        config: {
          body: { personIds },
        },
      })
    },
    [organization.id, request],
  )

  return [getBulkPersonNotes, status]
}

export default useGetBulkPersonNotes
